export enum ComponentType {
    /* eslint-disable @typescript-eslint/naming-convention  */
    /**
     * Note PascalCase : used in enum
     */
    ADMIN = 'Admin',
    CONSUMER_PORTAL = 'Consumer Portal',
    QUICK_LINK = 'Quick Link'
}
